import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import UserEditModal from './UserEditModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.userEditModal.status,
  user: state.modal.userEditModal.user,
  group: state.group,
  division: state.division
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_USER_EDIT, { status: false, user: {} }),
  updateUserById: actions.user.updateUserById,
  updateTable: actions.user.updateTable,
  getDivisions: actions.division.getDivisions
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserEditModal)



// WEBPACK FOOTER //
// ./src/components/Modals/UserEditModal/index.js